import React, { useEffect, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { apiCall, mediaUrl } from "../util";
import { FAQs } from "../Image";
import axios from "axios";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);
    const [data,setData]=useState([])
    const [titleData,setTitleData]=useState(null)

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        const response = await axios.get(apiCall + "faq/getall");
        setData(response.data.filter((item) => item.isView === 1).slice(0, 2));
        const result = await axios.post(apiCall + "faqtitle/getall");
        if (result.data[0]) {
          setTitleData(result.data[0]);
        }
      } catch (error) {
        console.error("Error fetching FAQ data:", error);
      }
    };
    fetchFaqData();
  }, []);



  return (
    <section className="bg-white overflow-hidden half-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-4 text-center text-md-start">
            <ScrollAnimation
              animateIn="animate__fadeInLeft"
              duration={1}
              animateOnce={true}
            >
              <div className="d-inline-flex gap-2 align-items-end justify-content-center">
                <img
                  src={FAQs}
                  className="h-70px"
                  alt="FAQ Icon"
                />
                <div className="text-start">
                  <span className="text-base-color fw-600 lh-1 text-uppercase d-block fs-12">
                    Hospital
                  </span>
                  <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                    FAQs
                  </h4>
                </div>
              </div>
              <img
                src={
                  titleData && titleData.image
                    ? `${mediaUrl}/${titleData.image}`
                    : "../assets/gokulam_images/faq-image.svg"
                }
                alt="FAQ Image"
                className="mt-40px"
              />
            </ScrollAnimation>
          </div>

          <div className="col-12 col-md-8">
            <ScrollAnimation
              animateIn="animate__fadeInRight"
              duration={1.2}
              animateOnce={true}
            >
              <div
                className="accordion accordion-style-03"
                id="accordion-style-03"
              >
                {data.map((item, index) => (
                  <div
                    key={item.id}
                    className={`accordion-item ${
                      activeIndex === index ? "active-accordion" : ""
                    }`}
                  >
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion(index)}
                    >
                      <div className="accordion-title position-relative mb-0 pe-25px">
                        <span className="text-dark-gray fw-bold alt-font">
                          {item.question}
                        </span>
                        <i
                          className={`fa-solid ${
                            activeIndex === index
                              ? "fa-angle-down"
                              : "fa-angle-right"
                          } icon-small text-dark-gray`}
                        ></i>
                      </div>
                    </div>
                    {activeIndex === index && (
                      <div className="accordion-collapse show">
                        <div className="accordion-body last-paragraph-no-margin">
                          <p className="text-dark-gray opacity-4">
                            {item.answer}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

// ////self useeffect
// import React, { useState, useEffect } from "react";
// import ScrollAnimation from "react-animate-on-scroll";
// import "animate.css/animate.min.css";
// import { apiCall, mediaUrl } from "../util";
// import axios from "axios";

// const FAQ = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [data, setData] = useState([]);
//   const [imageData, setImageData] = useState(null);

//   const toggleAccordion = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(apiCall + "faq/getall");
//         setData(response.data.filter((item) => item.isView === 1));

//         const imageResponse = await axios.post(apiCall + "faqtitle/getall");
//         if (imageResponse.data && imageResponse.data[0]) {
//           setImageData(imageResponse.data[0]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   return (
//     <section className="bg-white overflow-hidden half-section">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-12 col-md-4 text-center text-md-start">
//             <ScrollAnimation animateIn="animate__fadeInLeft" duration={1} animateOnce={true}>
//               <div className="d-inline-flex gap-2 align-items-end justify-content-center">
//               <img
//                 src="../assets/gokulam_images/icons/FAQs.png"
//                 className="h-70px"
//                 alt="FAQ Icon"
//               />
//                 <div className="text-start">
//                   <span className="text-base-color fw-600 lh-1 text-uppercase d-block fs-12">Hospital</span>
//                   <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">FAQs</h4>
//                 </div>
//               </div>
//               <img
//                 src={imageData && imageData.image ? `${mediaUrl}/${imageData.image}` : "../assets/gokulam_images/faq-image.svg"}
//                 alt="FAQ Image"
//                 className="mt-40px"
//               />
//             </ScrollAnimation>
//           </div>

//           <div className="col-12 col-md-8">
//             <ScrollAnimation animateIn="animate__fadeInRight" duration={1.2} animateOnce={true}>
//               <div className="accordion accordion-style-03" id="accordion-style-03">
//                 {data.map((item, index) => (
//                   <div key={item.id} className={`accordion-item ${activeIndex === index ? "active-accordion" : ""}`}>
//                     <div className="accordion-header" onClick={() => toggleAccordion(index)}>
//                       <div className="accordion-title position-relative mb-0 pe-25px">
//                         <span className="text-dark-gray fw-bold alt-font">{item.question}</span>
//                         <i
//                           className={`fa-solid ${activeIndex === index ? "fa-angle-down" : "fa-angle-right"} icon-small text-dark-gray`}
//                         ></i>
//                       </div>
//                     </div>
//                     {activeIndex === index && (
//                       <div className="accordion-collapse show">
//                         <div className="accordion-body last-paragraph-no-margin">
//                           <p className="text-dark-gray opacity-4">{item.answer}</p>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </ScrollAnimation>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQ;

////animejs
// import React, { useEffect, useState } from "react";
// import anime from "animejs";

// const FAQ = () => {
//   const [activeAccordion, setActiveAccordion] = useState("accordion-style-03-01");

//   const toggleAccordion = (id) => {
//     setActiveAccordion((prev) => (prev === id ? null : id));
//   };

//   useEffect(() => {
//     // Initialize anime.js animations when the component is mounted
//     const elements = document.querySelectorAll("[data-anime]");
//     elements.forEach((el) => {
//       const config = JSON.parse(el.getAttribute("data-anime"));
//       anime({
//         targets: config.el === "childs" ? el.children : el,
//         ...config,
//         loop: false, // Ensure animation doesn't loop
//       });
//     });
//   }, []);

//   return (
//     <section className="bg-white overflow-hidden half-section">
//       <div className="container">
//         <div className="row align-items-center">
//           <div
//             className="col-12 col-md-4 text-center text-md-start"
//             data-anime='{
//               "translateX": [50, 0],
//               "opacity": [0, 1],
//               "duration": 1200,
//               "delay": 0,
//               "staggervalue": 150,
//               "easing": "easeOutQuad"
//             }'
//           >
//             <div className="d-inline-flex gap-2 align-items-end justify-content-center">
{/* <img
  src="../assets/gokulam_images/icons/FAQs.png"
  className="h-70px"
  alt="FAQ Icon"
/>; */}
//               <div className="text-start">
//                 <span className="text-base-color fw-600 lh-1 text-uppercase d-block fs-12">Hospital</span>
//                 <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">FAQs</h4>
//               </div>
//             </div>
//             <img
//               src="../assets/gokulam_images/faq-image.svg"
//               alt="FAQ Image"
//               className="mt-40px"
//               style={{ width: "88%", height: "100%" }}
//             />
//           </div>
//           <div className="col-12 col-md-8">
//             <div className="accordion accordion-style-03" id="accordion-style-03">
//               {/* Accordion Item 1 */}
//               <div className="accordion-item">
//                 <div className="accordion-header">
//                   <button
//                     className={`accordion-button ${
//                       activeAccordion === "accordion-style-03-01" ? "" : "collapsed"
//                     }`}
//                     onClick={() => toggleAccordion("accordion-style-03-01")}
//                   >
//                     <span className="text-dark-gray fw-bold alt-font">
//                       Lorem ipsum dolor sit amet consectetur adipisicing elit
//                     </span>
//                   </button>
//                 </div>
//                 <div
//                   id="accordion-style-03-01"
//                   className={`accordion-collapse collapse ${
//                     activeAccordion === "accordion-style-03-01" ? "show" : ""
//                   }`}
//                 >
//                   <div className="accordion-body last-paragraph-no-margin">
//                     <p className="text-dark-gray opacity-4">
//                       Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quod iusto perferendis ipsa vero
//                       tempora cumque aut quas magnam debitis maiores incidunt libero, quam, expedita, fugit eius!
//                       Nesciunt, neque voluptatem?
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Accordion Item 2 */}
//               <div className="accordion-item">
//                 <div className="accordion-header">
//                   <button
//                     className={`accordion-button ${
//                       activeAccordion === "accordion-style-03-02" ? "" : "collapsed"
//                     }`}
//                     onClick={() => toggleAccordion("accordion-style-03-02")}
//                   >
//                     <span className="text-dark-gray fw-bold alt-font">
//                       Lorem ipsum dolor sit amet consectetur adipisicing elit
//                     </span>
//                   </button>
//                 </div>
//                 <div
//                   id="accordion-style-03-02"
//                   className={`accordion-collapse collapse ${
//                     activeAccordion === "accordion-style-03-02" ? "show" : ""
//                   }`}
//                 >
//                   <div className="accordion-body last-paragraph-no-margin">
//                     <p className="text-dark-gray opacity-4">
//                       Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quod iusto perferendis ipsa vero
//                       tempora cumque aut quas magnam debitis maiores incidunt libero, quam, expedita, fugit eius!
//                       Nesciunt, neque voluptatem?
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQ;
